import { apiGet, apiPatch, apiPost } from '@/shared/utils/requestBuilder';

import type {
  ContextoPesquisaApi,
  RegistrarDesfechoPayload,
  RegistrarExibicaoPayload,
} from '../types/pesquisaSatisfacaoTypes';

const BASE = '/pesquisas';

/**
 * Falha de pesquisa é invisível para quem está trabalhando (RNF-02): nenhuma
 * chamada daqui pode virar mensagem na tela. Quem lança é só o `carregarContexto`,
 * porque ali o thunk precisa saber que o contexto NÃO chegou — sem histórico, o
 * certo é não mostrar pesquisa nenhuma, e não mostrar a errada.
 */
const extrairMensagemDeErro = async (resposta: Response, padrao: string): Promise<string> => {
  const corpo = await resposta.json().catch(() => null);
  if (corpo && typeof corpo === 'object' && 'error' in corpo) {
    const erro = (corpo as { error?: unknown }).error;
    if (typeof erro === 'string' && erro.length > 0) return erro;
  }
  return padrao;
};

export const carregarContexto = async (): Promise<ContextoPesquisaApi> => {
  const resposta = await apiGet(`${BASE}/contexto`);
  if (!resposta.ok) {
    throw new Error(await extrairMensagemDeErro(resposta, 'Não foi possível carregar a pesquisa.'));
  }

  const corpo = (await resposta.json()) as { data: ContextoPesquisaApi };
  return corpo.data;
};

export const registrarExibicao = async (payload: RegistrarExibicaoPayload): Promise<void> => {
  const resposta = await apiPost(`${BASE}/exibicao`, payload);
  if (!resposta.ok) {
    throw new Error(
      await extrairMensagemDeErro(resposta, 'Não foi possível registrar a exibição.'),
    );
  }
};

export const registrarDesfecho = async ({
  correlacaoId,
  ...corpo
}: RegistrarDesfechoPayload): Promise<void> => {
  // `keepalive`: o cartão declara a nota enviada no primeiro clique, então fechar a
  // aba no instante seguinte não pode abortar o envio.
  const resposta = await apiPatch(
    `${BASE}/exibicao/${correlacaoId}`,
    corpo,
    false,
    undefined,
    true,
  );
  if (!resposta.ok) {
    throw new Error(
      await extrairMensagemDeErro(resposta, 'Não foi possível registrar a resposta.'),
    );
  }
};
